export default "__VITE_ASSET__Dia1$jKP__"